import React from 'react';
import PropTypes from 'prop-types';
import reactT from '../reactT';

/**
 * Displays search terms that were not found in any result.
 * Renders after the search bar with strikethrough styling.
 */
const MissingTerms = ({ terms }) => {
  if (!terms || terms.length === 0) {
    return null;
  }

  return (
    <div className="search-missing-terms">
      <span className="search-missing-terms__label">{reactT('Missing')}:</span>
      <span className="search-missing-terms__list">
        {terms.map((term, index) => (
          <span key={index} className="search-missing-terms__term">
            {term}{index < terms.length - 1 && ', '}
          </span>
        ))}
      </span>
    </div>
  );
};

MissingTerms.propTypes = {
  terms: PropTypes.arrayOf(PropTypes.string),
};

MissingTerms.defaultProps = {
  terms: [],
};

export default MissingTerms;
